/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

export type InteracRows = {
  label: string;
  id: vp.AddInteracId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
  type: 'input' | 'select' | 'toggle' | 'singleDate';
  placeholder: string;
  visible: (ctx: vp.InteracAddEmailRequest) => boolean;
  maxLength?: number;
  getSelectOptions: (ctx: vp.InteracAddEmailRequest) => { [key: string]: string };
};

export const buildInteracRows = (): InteracRows[] => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Accounts.MyBankAccounts.InteracDialogue.buildInteracRows',
  });

  const etransferConnection = {
    email: t('email'),
    phone: t('phone'),
  };

  return [
    {
      label: t('RecipientName'),
      id: vp.AddInteracId.RecipientName,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: '',
      visible: () => true,
      getSelectOptions: () => ({}),
    },
    {
      label: t('etransferConnectionType'),
      id: vp.AddInteracId.etransferConnectionType,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: t('Please Select...'),
      visible: () => true,
      getSelectOptions: () => etransferConnection,
    },
    {
      label: t('RecipientEmailAddress'),
      id: vp.AddInteracId.RecipientEmailAddress,
      require: true,
      preset: 'email',
      type: 'input',
      placeholder: '',
      visible: (ctx: vp.InteracAddEmailRequest) => ctx.etransferConnectionType !== 'phone',
      getSelectOptions: () => ({}),
    },
    {
      label: t('RecipientPhoneNumber'),
      id: vp.AddInteracId.RecipientPhoneNumber,
      require: true,
      preset: 'text',
      type: 'input',
      placeholder: '',
      visible: (ctx: vp.InteracAddEmailRequest) => ctx.etransferConnectionType === 'phone',
      getSelectOptions: () => ({}),
    },
    {
      label: t('Question'),
      id: vp.AddInteracId.Question,
      require: false,
      preset: 'text',
      type: 'input',
      placeholder: '',
      visible: () => true,
      getSelectOptions: () => ({}),
    },
    {
      label: t('Answer'),
      id: vp.AddInteracId.Answer,
      require: false,
      preset: 'text',
      type: 'input',
      placeholder: '',
      visible: () => true,
      getSelectOptions: () => ({}),
    },
    {
      label: t('ClientReferenceNumber'),
      id: vp.AddInteracId.ClientReferenceNumber,
      require: false,
      preset: 'text',
      type: 'input',
      placeholder: '',
      visible: () => true,
      getSelectOptions: () => ({}),
    },
    {
      label: t('Nickname'),
      id: vp.AddInteracId.Nickname,
      require: false,
      preset: 'text',
      type: 'input',
      placeholder: '',
      visible: () => true,
      getSelectOptions: () => ({}),
    },
  ];
};
